import React from 'react';
const Assessments = React.lazy(() => import('../pages/Assessments'));
const CarePlan = React.lazy(() => import('../pages/Careplan'));
const AuthorizeUser = React.lazy(() => import('../pages/Authentication/AuthorizeUser'));

const publicRoutes = [
    { path: '/:tenant/authorize/xp/:lang?/:uniquelink/:uniquekey/:pageName/:modeId', component: <AuthorizeUser /> },
    { path: '/:tenant/authorize/xp/:lang?/:uniquelink/:uniquekey', component: <AuthorizeUser /> },
    { path: '/:tenant/authorize/:uniquelink', component: <AuthorizeUser /> },

    { path: '/authorize/xp/:lang?/:uniquelink/:uniquekey/:pageName/:modeId', component: <AuthorizeUser /> },
    { path: '/authorize/xp/:lang?/:uniquelink/:uniquekey', component: <AuthorizeUser /> },
    { path: '/authorize/:uniquelink', component: <AuthorizeUser /> },
    { path: '/careplan', component: <CarePlan /> },
    { path: '/assessments', component: <Assessments /> }
];

export { publicRoutes };
